import Cookies from "js-cookie";
import { signUpWithCode, getCurrentUser, getSignUpCode  } from "@/util/APIUtils";

const TokenKey = "cg_token";
const subTokenKey = "loginToken";


export function getToken() {
  return window.localStorage.getItem(TokenKey);
}

export function getTokenKey() {
  return window.localStorage.getItem("cg_tk");
}

export function setToken(token) {
  try {
    Cookies.set(subTokenKey, token);
  } catch (e) {}
  return window.localStorage.getItem(TokenKey);
}

/**
 * 用code匿名登录
 * @param {string} code
 */
async function getSignUpToken(code) {
  const res = await signUpWithCode({
    szSignUpCode: code,
  });
  if (res.code == 0) {
    return res.data.sTokenKey;
  }
  return "";
}

/**
 * 获取指纹code后，用code匿名登录，返回token
 */
export async function getSignToken() {
  const code = await getSignCode();
  if (code != "") {
    const token = await getSignUpToken(code);
    if (token != "") {
      return token;
    }
  }
  return "";
}

/**
 * 获取指纹登录code
 */
async function getSignCode() {
  const res = await getSignUpCode();
  if (res.code == 0) {
    return res.data.sCode;
  }
  return "";
}


export async function getUser() {
  const res = await getCurrentUser();
  if (res.code == 0) {
    const tk = res.data.openid;
    if (tk != "") {
      return tk;
    }
  }
  return "";
}
